<template>
  <div>
    <div class="theme-swiper" v-if="type == 1">
      <!-- 首页banner轮播 -->
      <swiper
        v-if="bannerArr.length > 0"
        :options="swiperOption"
        ref="mySwiper"
      >
        <swiper-slide v-for="(item, index) in bannerArr" :key="index">
          <div class="item hand">
            <img :src="item" class="activity-img hand" />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 新闻中心banner轮播 -->
    <div class="news-swiper" v-if="type == 2">
      <swiper :options="swiperOption2" ref="mySwiper">
        <swiper-slide v-for="item in newsSwiperRes" :key="item.newsId">
          <div
            class="news-item flex-row hand"
            @click="toDetails(item.newsId, item.url)"
          >
            <img :src="item.newsImage" class="news-img hand" />
            <div class="news-info">
              <h3>{{ item.newsTitle }}</h3>
              <!-- <p v-html="item.newsContent"> -->
              <!-- 随着社会的不断发展，中国已进入品牌经济时代，品牌价值正在成为判断一个企业，是否具有潜力、值得期待、值得投资的重要标准。
                5月10日，在第六个中国品牌日到来之际，以品质精、敢创新、服务优、水长流为质量方针的冠龙节能，借此契机，和您分享冠龙品牌的创立之路...... -->
              <!-- </p> -->
              <time>{{
                $dayjs(item.releaseTime || item.createTime).format("YYYY-MM-DD")
              }}</time>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination2" slot="pagination"></div>
    </div>
    <div class="theme-swiper products-swiper" v-if="type == 3">
      <!-- 产品详情轮播 -->
      <swiper
        v-if="bannerArr.length > 0"
        :options="swiperOption3"
        ref="mySwiper"
      >
        <swiper-slide v-for="(item, index) in bannerArr" :key="index">
          <div
            class="products-swiper-item item hand items-center justify-center"
          >
            <img :src="item" class="activity-img hand" />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-prev3 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
      <div class="swiper-button-next3 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
    </div>
    <!-- 首页新闻中心 -->
    <div class="history-swiper" v-if="type == 4">
      <swiper :options="swiperOption4">
        <swiper-slide v-for="item in newsSwiperRes" :key="item.newsId">
          <div
            class="hand"
            style="width: 100%"
            @click="toDetails(item.newsId, item.url)"
          >
            <img :src="item.newsImage" />
            <div class="cover">
              <h1>{{ item.newsTitle }}</h1>
              <time>{{
                $dayjs(item.releaseTime || item.createTime).format("YYYY-MM-DD")
              }}</time>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 关于页面的发展历程 -->
    <div class="history-swiper develop-swiper" v-if="type == 5">
      <swiper :options="isPc ? swiperOption5 : swiperOption7">
        <swiper-slide v-for="(item, index) in historyListRes" :key="index">
          <div class="develop-swiper-item hand" style="width: 100%">
            <div class="develop-year items-center">{{ item.year }}</div>
            <div
              class="develop-month justify-start"
              v-for="(it, idx) in item.values"
              :key="idx"
            >
              <h3>{{ it.month }}</h3>
              <span>{{ it.historyEn }}</span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev5 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
      <div class="swiper-button-next5 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
    </div>
    <!-- 关于页面的公司资质 -->
    <div
      class=" develop-swiper qualification-swiper"
      v-if="type == 6"
    >
      <swiper :options="swiperOption6">
        <swiper-slide v-for="(item, index) in certificateListRes" :key="index">
          <div
            class="qualification-swiper-item flex-col items-center hand"
            style="width: 100%"
          >
            <img :src="item.certificateImage" />
            <h3>{{ item.certificateTitleEn }}</h3>
          </div>
        </swiper-slide>
      </swiper>
      <router-link :to="{ path: '/en_qualification' }">
        <div class="more items-center justify-end little_hand">
          more
          <svg-icon icon-class="direction"></svg-icon>
        </div>
      </router-link>
      <div class="swiper-button-prev6 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
      <div class="swiper-button-next6 items-center justify-center hand">
        <svg-icon icon-class="arrow"></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    type: {},
    bannerArr: {},
    historyArr: {},
    certificateListRes: {},
    historyListRes: {},
    newsSwiperRes: {},
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1, //一页显示几个
        spaceBetween: 0, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
      },
      swiperOption2: {
        slidesPerView: 1, //一页显示几个
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        speed: 1500,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination2",
          clickable: true,
        },
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          disableOnInteraction: false,
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
      },
      swiperOption3: {
        slidesPerView: 1, //一页显示几个
        spaceBetween: 0, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next3", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev3", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled3", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden3", //按钮隐藏时的Class
        },
      },
      swiperOption4: {
        slidesPerView: 2.7, //一页显示几个
        spaceBetween: 20,
        loop: false,
        speed: 500,
        autoplay: false,
      },
      swiperOption5: {
        slidesPerView: 3.4, //一页显示几个
        spaceBetween: 16,
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next5", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev5", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled5", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden5", //按钮隐藏时的Class
        },
      },
      swiperOption7: {
        slidesPerView: 1.2, //一页显示几个
        spaceBetween: 16,
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next5", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev5", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled5", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden5", //按钮隐藏时的Class
        },
      },
      swiperOption6: {
        slidesPerView: "auto", //一页显示几个
        spaceBetween: 40,
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next6", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev6", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled6", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden6", //按钮隐藏时的Class
        },
      },
      swiperOption8: {
        slidesPerView: 1.4, //一页显示几个
        spaceBetween: 40,
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next6", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev6", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled6", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden6", //按钮隐藏时的Class
        },
      },
      indexHistory: "",
    };
  },
  computed: {
    ...mapState(["isPc", "validToken", "userInfo", "user_id"]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    // indexHistory() {
    //   return this.historyArr[0].article_id;
    // },
  },
  watch: {
    historyArr(val) {
      if (val.length > 0) {
        this.indexHistory = val[0].article_id;
      }
    },
  },
  methods: {
    slideChange() {
      console.log(this.$refs.mySwiper.swiper.activeIndex);
    },
    fnToArticle(article_id) {
      this.indexHistory = article_id;
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
    toMore() {
      this.$router.push({
        path: `/theme`,
      });
    },
    toSwipe(item) {
      // alert(item);
    },
    toDetails(newsId, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/news-details/${newsId}`,
        });
      }
    },
  },
  created() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.theme-swiper {
  position: relative;
  z-index: 9;
  .swiper-btn {
    display: flex;
    align-items: center;
    justify-content: end;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .swiper-button-prev,
  .swiper-button-next {
    position: static;
    width: 60px;
    height: 60px;
    border: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    margin-top: 0;
    img {
      width: 30px;
      height: 30px;
      object-fit: contain;
    }
  }
  .swiper-button-prev {
    background: #e43d3f;
  }
  .swiper-button-next {
    background: #ffffff;
    transform: rotate(-180deg);
  }
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    // background: #fff;
    width: 100% !important;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    // transform: scale(0.8);
  }
  .swiper-pagination {
    bottom: 20px;
  }
}
.news-swiper {
  margin-bottom: 4px;
  position: relative;
  .news-img {
    width: 660px;
    height: 400px;
    object-fit: cover;
  }
  .news-info {
    height: 400px;
    background: #f8f8fa;
    padding: 24px;
    box-sizing: border-box;
    h3 {
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 36px;
      margin-bottom: 16px;

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    p {
      font-family: MicrosoftYaHei;
      color: #2c2c2e;
      line-height: 24px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
      word-break: break-all;
      height: 224px;
    }
    time {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #aeaeb2;
      line-height: 19px;
      margin-top: 16px;
    }
  }
  .swiper-pagination2 {
    position: absolute;
    bottom: 8px;
    left: 684px;
    z-index: 9;
    width: max-content;
  }
}
.products-swiper {
  position: relative;

  .products-swiper-item {
    width: 100%;
    height: 480px;
    background: #f2f2f7;
    img {
      height: 466px;
      width: 60%;
      object-fit: contain;
    }
  }
  .swiper-button-prev3 {
    position: absolute;
    top: 50%;
    left: 20px;
    z-index: 9;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.08);
    transform: translateY(-50%) rotate(180deg);
  }
  .swiper-button-next3 {
    right: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9;

    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.08);
  }
  .svg-icon {
    color: #2c2c2e;
  }
  .my-button-disabled3 {
    background: rgba($color: #000000, $alpha: 0.01);
    .svg-icon {
      color: rgba($color: #2c2c2e, $alpha: 0.4);
    }
  }
}
.history-swiper {
  .swiper-container {
    overflow: visible;
  }
  .swiper-slide {
    position: relative;
    display: flex;
    box-sizing: border-box;
    .cover {
      padding: 8px;
      h1 {
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #2c2c2e;
        line-height: 21px;
      }
      time {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #aeaeb2;
        line-height: 19px;
        margin-top: 4px;
      }
    }
  }

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
}

// 发展历程
.develop-swiper {
  position: relative;
  .develop-swiper-item {
    height: fit-content;
    .develop-year {
      font-size: 24px;
      font-family: Arial-BoldItalicMT, Arial;
      font-weight: normal;
      color: #2c2c2e;
      line-height: 28px;
    }
    .develop-year::after {
      content: "";
      margin-left: 16px;
      display: flex;
      width: fit-content;
      height: 2px;
      background: #e5e5ea;
      flex: 1;
    }
    .develop-month {
      margin-top: 14px;
      h3 {
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #2c2c2e;
        line-height: 22px;
        white-space: nowrap;
        margin-right: 8px;
      }
      span {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #2c2c2e;
        line-height: 22px;
      }
    }
  }
  .swiper-button-prev5 {
    position: absolute;
    top: -65px;
    left: 900px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.04);
    transform: rotate(180deg);
  }
  .swiper-button-next5 {
    left: 956px;
    position: absolute;
    top: -65px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.04);
  }
  .svg-icon {
    color: #2c2c2e;
  }
  .my-button-disabled5 {
    background: rgba($color: #000000, $alpha: 0.01);
    .svg-icon {
      color: rgba($color: #2c2c2e, $alpha: 0.4);
    }
  }
}
// 公司资质
.qualification-swiper {
  .swiper-container {
    overflow: visible;
  }
  .qualification-swiper-item {
    img {
      // width: 100%;
      height: 340px;
      object-fit: contain;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.24);
    }
    h3 {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
      margin-top: 8px;
    }
  }
  .swiper-slide {
    width: auto;
  }
  .swiper-button-prev6 {
    position: absolute;
    top: -65px;
    left: 900px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.39);
    transform: rotate(180deg);
  }
  .swiper-button-next6 {
    left: 956px;
    position: absolute;
    top: -65px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: rgba($color: #000000, $alpha: 0.39);
  }
  .svg-icon {
    color: #fff;
  }
  .my-button-disabled6 {
    background: rgba($color: #000000, $alpha: 0.2);
    .svg-icon {
      color: rgba($color: #fff, $alpha: 0.4);
    }
  }
}
.more {
  position: absolute;
  top: -56px;
  left: 760px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
  .svg-icon {
    width: 32px;
    height: 16px;
    margin-left: 8px;
  }
}

.activity-img {
  width: 100%;
  height: 640px;
  max-height: 640px;
}
.item {
  position: relative;
  width: 100%;
  display: flex;
}
.play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
}

@media screen and (max-width: 768px) {
  // 发展历程
  .develop-swiper {
    position: relative;
    .develop-swiper-item {
      height: fit-content;
    }
    .swiper-button-prev5 {
      top: -52px;
      left: auto;
      right: 52px;
    }
    .swiper-button-next5 {
      left: auto;
      right: 0;
      top: -52px;
    }
  }
  // 公司资质
  .qualification-swiper {
    .qualification-swiper-item {
      img {
        height: 260px;
      }
    }
    .more {
      position: absolute;
      top: -42px;
      right: 108px;
      left: auto;
      font-size: 14px;
      .svg-icon {
        width: 24px;
        height: 12px;
        margin-left: 4px;
      }
    }
    .swiper-button-prev6 {
      top: -52px;
      left: auto;
      right: 52px;
    }
    .swiper-button-next6 {
      left: auto;
      right: 0;
      top: -52px;
    }
  }
  .products-swiper {
    position: relative;
    .products-swiper-item {
      width: 100%;
      height: 200px;
      background: #f2f2f7;
      img {
        height: 190px;
        width: 60%;
        object-fit: contain;
      }
    }
  }
  .news-swiper {
    margin-bottom: 4px;
    position: relative;
    .news-item {
      flex-direction: column;
      .news-img {
        min-width: 100%;
        width: 100%;
        height: 214px;
        object-fit: cover;
      }
      .news-info {
        height: auto;
        padding: 16px 16px 40px;
        h3 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 8px;
        }
        p {
          font-size: 14px;
          line-height: 24px;
          -webkit-line-clamp: 6;
          height: 144px;
        }
      }
    }

    .swiper-pagination2 {
      position: absolute;
      bottom: 6px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
      width: max-content;
    }
  }
}
</style>
<style>
.swiper-pagination-bullet {
  width: 40px;
  height: 4px;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
  opacity: 1;
}
.swiper-pagination-bullet-active {
  background: #005bac;
}
.swiper-pagination2 .swiper-pagination-bullet {
  background: #c7c7cc;
  margin-right: 8px;
}
.swiper-pagination2 .swiper-pagination-bullet-active {
  width: 196px;
  background: #005bac;
}
@media screen and (max-width: 768px) {
  .products-swiper .swiper-pagination {
    bottom: 6px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/en/common/swiper.vue